import { PartialRecursive } from '@bridebook/models/source/abstract/_';
import { IBucket } from '@bridebook/models/source/models/Countries/Buckets.types';

const result: PartialRecursive<IBucket['settings']> = {
  searchFilters: {
    venue: {
      venueType: [
        'barn',
        'conferenceCentre',
        'countryHouseManorHouse',
        'cruiseBoatYacht',
        'gardenOutdoor',
        'golfCourse',
        'hotel',
        'museumAttraction',
        'placeOfWorship',
        'pubRestaurant',
        'rooftop',
        'winery',
      ],
    },
  },
  forcedCuratedListSearch: true,
};

export default result;
